import {computed, signal} from "@preact/signals-react";
import {TOP_KPI} from "../constants";

export const topSellersAllData = signal({})
export const isLoadingTopSellers = signal(false)
export const topSellersTab = signal(TOP_KPI.PRODUCTS)

// Computed
export const topSellersCurrentData = computed(() => topSellersAllData.value[topSellersTab.value] || [])